var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "imageTextResource" },
    _vm._l(_vm.imageText, function (item, index) {
      return _c("div", {
        key: index,
        staticClass: "htmlBox",
        domProps: { innerHTML: _vm._s(item.content) },
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/resource/imageTextResource.vue?vue&type=template&id=58fa2db6&
// module id = null
// module chunks = 